import React from "react"
import ReactDOM from "react-dom"
import {fonts} from "@uprise/core"
import "./index.css"
// base
import "./styles/base.css"
// import App from "./App"
import {Provider} from "react-redux"
import * as serviceWorker from "./serviceWorker"
import {Auth0Provider} from "@auth0/auth0-react"
import {oauth_client_id, oauth_domain, oauth_audience} from "./config/auth0-config"

// UI
import {ModalRoot} from "@uprise/modal"
// Store
import configureAppStore from "./app/store"
// History
import history from "./utils/history"

// base
import "./styles/base.css"

const {store} = configureAppStore()

const onRedirectCallback = async appState => {
	history.replace({
		pathname: appState?.returnTo || window.location.pathname,
		search: ""
	})
}

const render = () => {
	const App = require("./App").default

	ReactDOM.render(
		<React.StrictMode>
			<Provider store={store}>
				{/* <PersistGate loading={null} persistor={persistor}> */}
				<Auth0Provider
					domain={oauth_domain}
					clientId={oauth_client_id}
					redirectUri={window.location.origin}
					audience={oauth_audience}
					onRedirectCallback={onRedirectCallback}
					cacheLocation="localstorage"
					scope='openid email app_metadata'>
					<App />
					<ModalRoot />
				</Auth0Provider>
				{/* </PersistGate> */}
			</Provider>
		</React.StrictMode>,
		document.getElementById("root")
	)
}

render()

// HMR - Create React App 4 / Webpack specific
if (process.env.NODE_ENV === "development" && module.hot) {
	module.hot.accept("./App", render)
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
